import { useNavigate, useParams } from "react-router-dom";
import { PurchaseOrderDetailsView } from "@surgia/ui";
import { ADMIN_PROTECTED_ROUTES } from "../../routes";

// Import the modal from hub (since admin uses the same one)
import PurchaseRequestDetailsModal from "../../../../hub-surgia/src/containers/Modals/PurchaseRequestDetailsModal";

function AdminPurchaseOrderDetailsView() {
  const navigate = useNavigate();
  const { id: tenantId, poId: purchaseOrderId } = useParams();

  const breadcrumbItems = [
    {
      label: "Tenants",
      onClick: () => navigate(ADMIN_PROTECTED_ROUTES.TENANTS),
      show: true,
    },
    {
      label: "Tenant Details",
      onClick: () =>
        navigate(
          ADMIN_PROTECTED_ROUTES.TENANT_DETAILS.replace(":id", tenantId || "")
        ),
      show: true,
    },
    {
      label: "Purchase Orders",
      show: true,
    },
    {
      label: "View purchase order",
      show: true,
    },
  ];

  return (
    <PurchaseOrderDetailsView
      tenantId={tenantId || ""}
      purchaseOrderId={purchaseOrderId || ""}
      componentId={import.meta.env.VITE_PUBLIC_COMPONENT_ID || ""}
      breadcrumbItems={breadcrumbItems}
      userPermissions={[]}
      canViewPurchaseRequests={false}
      isSuperAdmin={true}
      PurchaseRequestDetailsModal={PurchaseRequestDetailsModal}
      showSkeletonLoading={true}
      VIEW_PURCHASE_REQUEST_PERMISSION="VIEW_PURCHASE_REQUEST"
    />
  );
}

export default AdminPurchaseOrderDetailsView;
